'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _getHighestQualityVideoUrl = require('../../../utils/getHighestQualityVideoUrl');

var _getHighestQualityVideoUrl2 = _interopRequireDefault(_getHighestQualityVideoUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// recommendations API videoSources look like: [{ 720: 'path-to-file.mp4' }]
function recommendationToPlayable(recommendation) {
  var mappedVideoSources = (0, _map2.default)(recommendation.videoSources, function (source, quality) {
    return { url: source, quality: quality };
  });

  return {
    communityContentId: recommendation.communityContentId,
    src: (0, _getHighestQualityVideoUrl2.default)(mappedVideoSources)
  };
}

exports.default = {
  recommendationToPlayable: recommendationToPlayable
};